import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './Navbar';
import Footer from './Footer';
import RoutesConfig from './routes';
import { AuthProvider } from './AuthContext';
import { UploadGuardProvider } from './UploadGuardContext';
import './App.css';

const App = () => (
  <HelmetProvider>
    <AuthProvider>
      <Router>
        <UploadGuardProvider>
          <div className="app-shell">
            <Navbar />
            <main className="content">
              <RoutesConfig />
            </main>
            <Footer />
          </div>
        </UploadGuardProvider>
      </Router>
    </AuthProvider>
  </HelmetProvider>
);

export default App;
